import { Component, type ReactNode } from 'react';
import type { MarkdownEditorProps } from './MarkdownEditor';
import * as s from './MarkdownEditor.css';

export class EditorLoadBoundary extends Component<
  { readonly children: ReactNode; readonly fallback: ReactNode },
  { readonly failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

export function EditorFallback({
  editorProps,
  children,
}: {
  readonly editorProps: MarkdownEditorProps;
  readonly children: ReactNode;
}) {
  const { density, ruled, className, headerSlot, footerSlot, minHeight = 160 } = editorProps;
  const wrapperClass = [
    s.editorWrapper,
    density === 'comfortable' && s.editorComfortable,
    ruled && s.editorRuled,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={s.container}>
      <div className={wrapperClass}>
        {headerSlot}
        <div className={s.markdownBody} style={{ minHeight }}>
          {children}
        </div>
        {footerSlot}
      </div>
    </div>
  );
}
